import { useDispatch, useSelector, TypedUseSelectorHook } from 'react-redux'
import type { RootState, AppDispatch } from './index'

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch = () => useDispatch<AppDispatch>()
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector

// Auth selectors
export const useAuth = () => useAppSelector((state) => state.auth)
export const useUser = () => useAppSelector((state) => state.auth.user)
export const useIsAuthenticated = () => useAppSelector((state) => state.auth.isAuthenticated)
export const useAuthLoading = () => useAppSelector((state) => state.auth.isLoading)
export const useAuthError = () => useAppSelector((state) => state.auth.error)
export const useToken = () => useAppSelector((state) => state.auth.token)
export const useSessionId = () => useAppSelector((state) => state.auth.sessionId)

// UI selectors
export const useUI = () => useAppSelector((state) => state.ui)
export const useSidebarOpen = () => useAppSelector((state) => state.ui.sidebarOpen)
export const useTheme = () => useAppSelector((state) => state.ui.theme)
export const useNotifications = () => useAppSelector((state) => state.ui.notifications)
export const useLoading = () => useAppSelector((state) => state.ui.loading)
export const useModals = () => useAppSelector((state) => state.ui.modals)
export const useToast = () => useAppSelector((state) => state.ui.toast)
